import {Loading} from '@hm/fundamental'
import {buildFeatureUrl} from '@hproduce/suite-core'
import {useCallback} from 'react'
import {useNavigate} from 'react-router'

import {MenuNodeType} from '../../../api/types/featuresMenu'
import {useFeaturesMenu} from '../../../app/welcomeFlow/useFeaturesMenu'
import {useHierarchyIdFromURL} from '../header/PlantSelectButton/useHierarchyIdFromUrl'

import {FeatureMenuNode} from './features-tree.utils'
import {FeaturesTree} from './FeaturesTree'
import {SettingsAppLink} from './SettingsAppLink'

export const FeatureMenuDesktop: React.FC = () => {
  const {featuresMenu, homeFeature, isLoading} = useFeaturesMenu()
  const navigate = useNavigate()
  const [hierarchyId] = useHierarchyIdFromURL()

  const handleSelect = useCallback(
    (node?: FeatureMenuNode) => {
      const isFeatureNode = node && node.type === MenuNodeType.Feature
      if (isFeatureNode) {
        void navigate(buildFeatureUrl(node.name, hierarchyId))
      }
    },
    [navigate, hierarchyId]
  )

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loading size="large" data-cy="feature_menu_loader" />
      </div>
    )
  }

  return (
    <div data-cy="features_menu_desktop" className="flex flex-col gap-4">
      <SettingsAppLink />
      {featuresMenu && (
        <FeaturesTree
          featuresMenu={featuresMenu}
          homeFeature={homeFeature}
          onSelectItem={handleSelect}
        />
      )}
    </div>
  )
}
